var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"code",staticClass:"code-editor"})
}
var staticRenderFns = []

export { render, staticRenderFns }